interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  trend?: string;
}

export default function StatCard({ title, value, subtitle, trend }: StatCardProps) {
  return (
    <div className="dashboard-card transition hover:border-[var(--primary)]/40">
      <p className="text-sm font-medium text-[var(--muted)]">{title}</p>
      <p className="mt-2 text-3xl font-bold tracking-tight text-[var(--fg)]">
        {value}
      </p>
      {(subtitle || trend) && (
        <p className="mt-1 flex items-center gap-2 text-xs text-[var(--muted)]">
          {subtitle && <span>{subtitle}</span>}
          {trend && (
            <span className="font-medium text-[var(--success)]">{trend}</span>
          )}
        </p>
      )}
    </div>
  );
}
